import { render, staticRenderFns } from "./ProductDetail2.vue?vue&type=template&id=3eddd229&scoped=true"
import script from "./ProductDetail2.vue?vue&type=script&lang=js"
export * from "./ProductDetail2.vue?vue&type=script&lang=js"
import style0 from "./ProductDetail2.vue?vue&type=style&index=0&id=3eddd229&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eddd229",
  null
  
)

export default component.exports